import { GoogleAuthProvider, GoogleSignInButton, useGoogleAuth } from '@questlabs/auth-js';
import { BrowserRouter } from 'react-router-dom';
import Studio from './components/Studio';
import './App.css';

function LoginScreen() {
  return (
    <main className="login-shell">
      <section className="login-card">
        <p className="eyebrow">SANS TITRE · PRIVATE ACCESS</p>
        <h1>SceneFlow<br />Studio</h1>
        <p>Synchronize generated footage with the written scene.</p>
        <GoogleSignInButton />
        <small>Access is managed by the SANS TITRE workspace administrator.</small>
      </section>
    </main>
  );
}

function AuthenticatedApp() {
  const { user, initialized, loading } = useGoogleAuth();

  if (!initialized || loading) {
    return <div className="loading-screen"><span /><p>Restoring studio session</p></div>;
  }

  return user ? <Studio user={user} /> : <LoginScreen />;
}

export default function App() {
  return (
    <GoogleAuthProvider>
      <BrowserRouter>
        <AuthenticatedApp />
      </BrowserRouter>
    </GoogleAuthProvider>
  );
}